import type { TFunction } from 'i18next';

import type { ReportKind } from './types';

const labelKeys: Readonly<Record<ReportKind, string>> = Object.freeze({
  transactions: 'reports.kinds.transactions',
  'agent-commissions': 'reports.kinds.agentCommissions',
  'affiliate-commissions': 'reports.kinds.affiliateCommissions',
  games: 'reports.kinds.games',
  registrations: 'reports.kinds.registrations',
  'partner-reconciliation': 'reports.kinds.partnerReconciliation',
  'commission-rule-usage': 'reports.kinds.commissionRuleUsage',
  'audit-activity': 'reports.kinds.auditActivity',
  wallets: 'reports.kinds.wallets',
  'wallet-ledger': 'reports.kinds.walletLedger',
  withdrawals: 'reports.kinds.withdrawals',
  'partner-credit-reconciliation': 'reports.kinds.partnerCreditReconciliation',
  'user-affiliate-by-game': 'reports.kinds.userAffiliateByGame',
});

const apiKinds: Readonly<Record<string, ReportKind>> = Object.freeze({
  TRANSACTIONS: 'transactions',
  AGENT_COMMISSIONS: 'agent-commissions',
  AFFILIATE_COMMISSIONS: 'affiliate-commissions',
  GAMES: 'games',
  REGISTRATIONS: 'registrations',
  PARTNER_RECONCILIATION: 'partner-reconciliation',
  COMMISSION_RULE_USAGE: 'commission-rule-usage',
  AUDIT_ACTIVITY: 'audit-activity',
  WALLETS: 'wallets',
  WALLET_LEDGER: 'wallet-ledger',
  WITHDRAWALS: 'withdrawals',
  PARTNER_CREDIT_RECONCILIATION: 'partner-credit-reconciliation',
  USER_AFFILIATE_BY_GAME: 'user-affiliate-by-game',
});

export function reportKindLabel(kind: ReportKind, t: TFunction): string {
  return t(labelKeys[kind]);
}

export function apiReportKindLabel(apiKind: string, t: TFunction): string {
  const kind = apiKinds[apiKind];
  return kind === undefined ? t('common.unknown') : reportKindLabel(kind, t);
}

const filterLabelKeys: Readonly<Record<string, string>> = Object.freeze({
  from: 'reports.from',
  to: 'reports.to',
  timezone: 'reports.timezone',
  timeBasis: 'reports.timeBasis',
  partnerId: 'reports.partnerId',
  agentId: 'reports.agentId',
  memberId: 'reports.memberId',
  uplineMemberId: 'reports.uplineMemberId',
  gameTypeId: 'reports.gameTypeId',
  gameId: 'reports.gameId',
  currency: 'reports.currency',
  status: 'reports.status',
  outcome: 'filters.outcome',
  code: 'filters.code',
  username: 'filters.username',
  partnerUserId: 'filters.partnerUserId',
  entryType: 'filters.entryType',
  sort: 'reports.sort',
});

export function reportFilterLabel(field: string, t: TFunction): string {
  const key = filterLabelKeys[field];
  return key === undefined ? t('common.unknown') : t(key);
}
